import React from 'react';
import classNames from 'classnames';

export const StatusCell = ({ value }: any) => {
  const className = `status-cell${value ? '' : '-closed'}`;

  return <div className={classNames({ className })}>{value ? 'Active' : 'Closed'}</div>;
};
